import actions from "./actions";

const initState = {
    // Create User
    users: [],
    createUserLoading: false,
    createUserError: null,
    createUserMessage: null,

    // Assignable Roles
    roleList: [],
    getRoleLoading: false,

    // User List
    userList: [],
    getUserListLoading: false,
    getUserListError: null,

    // Modify User
    modifyUserLoading: false,
    modifyUserError: null,
    modifyUserMessage: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        // CREATE USER
        case actions.CREATE_USER:
            return {
                ...state,
                users: [],
                createUserLoading: true,
                createUserError: null,
                createUserMessage: null,
            };

        case actions.CREATE_USER_SUCCESS:
            return {
                ...state,
                createUserLoading: false,
                createUserError: null,
                createUserMessage: action.message,
            };

        case actions.CREATE_USER_FAILED:
            return {
                ...state,
                createUserLoading: false,
                createUserError: action.error,
                createUserMessage: null,
            };
        // GET ASSIGNABLE ROLES
        case actions.GET_ASSIGNABLE_ROLES:
            return {
                ...state,
                getRoleLoading: true,
            };

        case actions.GET_ASSIGNABLE_ROLES_SUCCESS:
            return {
                ...state,
                roleList: action.payload.data,
                getRoleLoading: false,
            };

        case actions.GET_ASSIGNABLE_ROLES_FAILED:
            return {
                ...state,
                getRoleLoading: false,
            };
        // GET USER LIST
        case actions.GET_USER_LIST:
            return {
                ...state,
                getUserListLoading: true,
                getUserListError: null,
            };

        case actions.GET_USER_LIST_SUCCESS:
            return {
                ...state,
                userList: action.payload.data,
                getUserListLoading: false,
                getUserListError: null,
            };

        case actions.GET_USER_LIST_FAILED:
            return {
                ...state,
                getUserListLoading: false,
                getUserListError: action.error,
            };
        // MODIFY USER
        case actions.MODIFY_USER:
            return {
                ...state,
                modifyUserLoading: true,
                modifyUserError: null,
                modifyUserMessage: null,
            };

        case actions.MODIFY_USER_SUCCESS:
            return {
                ...state,
                modifyUserLoading: false,
                modifyUserError: null,
                modifyUserMessage: action.message,
            };

        case actions.MODIFY_USER_FAILED:
            return {
                ...state,
                modifyUserLoading: false,
                modifyUserError: action.error,
                modifyUserMessage: null,
            };
        // RESET
        case actions.RESET_MESSAGE:
            return {
                ...state,
                createUserMessage: null,
                createUserError: null,
                getUserListError: null,
                modifyUserMessage: null,
                modifyUserError: null,
            };

        default:
            return state;
    }
}